import { createAction } from 'redux-actions';
import { isNull } from 'lodash';
import { callApi, getEndpoint } from '../../../utils/api';
import {
  BUY_TRANSACTION,
  EXCHANGE_TRANSACTION,
  SELL_TRANSACTION,
  transactionType,
} from '../../../utils/transactions-util';
import {
  BUY,
  EXCHANGE,
  SELL,
  TransactionTypes,
} from '../../../settings/settings';

const TRANSACTION_HISTORY = 'TRANSACTION_HISTORY';
const TRANSACTION_HISTORY_YTD = 'TRANSACTION_HISTORY_YTD';

export default function transactionHistory(
  state = {
    hasError: false,
    isLoading: false,
    isLoaded: false,
    error: null,
    transactions: {},
    transactionsYTD: {},
  },
  { payload, type }
) {
  switch (type) {
    case `${TRANSACTION_HISTORY}_PENDING`:
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
      };
    case `${TRANSACTION_HISTORY}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        transactions: isNull(payload.body) ? {} : payload.body,
      };
    case `${TRANSACTION_HISTORY}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        hasError: true,
        error: payload,
      };
    case `${TRANSACTION_HISTORY_YTD}_PENDING`:
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
      };
    case `${TRANSACTION_HISTORY_YTD}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        transactionsYTD: isNull(payload.body) ? {} : payload.body,
      };
    case `${TRANSACTION_HISTORY_YTD}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        hasError: true,
        error: payload,
      };
    case `${TRANSACTION_HISTORY}_${BUY}_PENDING`:
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
      };
    case `${TRANSACTION_HISTORY}_${BUY}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        transactions: isNull(payload.body) ? {} : payload.body,
      };
    case `${TRANSACTION_HISTORY}_${BUY}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        hasError: true,
        error: payload,
      };
    case `${TRANSACTION_HISTORY}_${SELL}_PENDING`:
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
      };
    case `${TRANSACTION_HISTORY}_${SELL}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        transactions: isNull(payload.body) ? {} : payload.body,
      };
    case `${TRANSACTION_HISTORY}_${SELL}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        hasError: true,
        error: payload,
      };
    case `${TRANSACTION_HISTORY}_${EXCHANGE}_PENDING`:
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
      };
    case `${TRANSACTION_HISTORY}_${EXCHANGE}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        transactions: isNull(payload.body) ? {} : payload.body,
      };
    case `${TRANSACTION_HISTORY}_${EXCHANGE}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        hasError: true,
        error: payload,
      };
    default:
      return state;
  }
}

export const getTransactionHistory = (type = transactionType()) => {
  let endpoint = `${getEndpoint('transactionHistory')}?transactionType=${
    TransactionTypes[SELL]
  }`;
  let actionType = TRANSACTION_HISTORY;
  switch (type) {
    case BUY:
    case BUY_TRANSACTION: {
      endpoint = `${getEndpoint('transactionHistory')}?transactionType=${
        TransactionTypes[BUY]
      }`;
      actionType = `${actionType}_${BUY}`;
      break;
    }
    case SELL:
    case SELL_TRANSACTION: {
      endpoint = `${getEndpoint('transactionHistory')}?transactionType=${
        TransactionTypes[SELL]
      }`;
      actionType = `${actionType}_${SELL}`;
      break;
    }
    case EXCHANGE:
    case EXCHANGE_TRANSACTION: {
      endpoint = `${getEndpoint('transactionHistory')}?transactionType=${
        TransactionTypes[EXCHANGE]
      }`;
      actionType = `${actionType}_${EXCHANGE}`;
      break;
    }
    default: {
      endpoint = `${getEndpoint('transactionHistory')}?transactionType=${
        TransactionTypes[SELL]
      }`;
    }
  }

  return (dispatch) => {
    const action = createAction(actionType)(callApi(endpoint));
    return dispatch(action);
  };
};

export const getTransactionHistoryYTD = () => {
  return (dispatch) => {
    const action = createAction(TRANSACTION_HISTORY_YTD)(
      callApi(getEndpoint('transactionHistoryYTD'))
    );
    dispatch(action);
  };
};
